import { CurrencyService } from 'src/app/services/currency.service';
import { BehaviorSubject, forkJoin } from 'rxjs';
import DateUtils from 'src/app/utils/date';
import { DealModel } from 'src/app/models/deal.model';
import { Component, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions, ApexXAxis
} from "ng-apexcharts";
import { DealsService } from 'src/app/services/deals.service';
import { map } from 'rxjs/operators';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import { Observable } from 'rxjs';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};
@Component({
  selector: 'app-new-deal-report',
  templateUrl: './new-deal-report.component.html',
  styleUrls: ['./new-deal-report.component.css']
})
export class NewDealReportComponent implements OnInit {
  dateUtil = new DateUtils;
  selectedStatus = '';
  public chartOptions = {
    series: [
      {
        name: "deal value",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
    colors: ["rgb(255,177,193))"]
  };
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
        { title:  "Salesperson", key:  "name" },
        { title:  "Count", key:  "count" },
        { title:  `Amount`, key:  "amount", transform: (f) => this.transformAmount(f) },
    ],
    rows: null,
    options: {
      debug: false, // change to true if you want to see datatable events
      noOfRowsToDisplay: 3, // change the amount of data you want to display at a particular time
      bulkActions: [],
      singleActions: [],
    }
  }
  dealsData
  years: any[];
  selectedYr = new Date().getFullYear();
  selectedPeriod = 'monthly';
  allReasonList$: Observable<any[]>;
  months = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  selectedReason = 'All'
  result;
  selectedIds = null; selectedType = null;
  baseCurrency
  unfilteredTableResult: DealModel[]
  constructor(
    private dealSrv: DealsService,
    private currencySrv: CurrencyService,
    private reportSetSrv: ReportSettingsService,
    private performRepSrv: PerformanceReportService,
    private dealworkflowSrv: DealPipelineWorkflowService) {
    this.years = this.dateUtil.getYears();
    this.allReasonList$ = (this.dealworkflowSrv.fetchDealReasons() as any);
    this.currencySrv.org_currencies.subscribe((org_currencies) => {
      this.baseCurrency = org_currencies && org_currencies.base_currency ? org_currencies.base_currency : "";
      this.dataTable.heads[2].title = `Amount (${this.baseCurrency})`
    });
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
      }
    })
  }
  transformAmount(amount) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(amount)
  }

  ngOnInit() {
    // this.getData();
    this.getNewDeals();
  }
  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.getData();
  }
  private getDealQuery(value, status, filter = 'SALESPERSON') {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const query = {
      endDate: getEndTimeStp(new Date()),
      startDate: getTsByNum(value),
      status,
      filter
    } 
    return query;
  }

  getData() {
    this.resetGraph();
    const dateFilter = this.dateUtil.getYearToDateRange(this.selectedYr);
    let filter: any = { dateFilter }
    if (this.selectedType === 'salesperson') {
      filter = { ...filter, salesPerson: { ids: this.selectedIds } }
    }
    const getDeals = this.dealSrv.fetchDeals(this.selectedIds, filter);
    const query = `itemType=Deals&range={"createdOn":{"from":${dateFilter.startDate},"to":${dateFilter.endDate}}}`;
    const getCurEqui = this.currencySrv.filter_organisation_currencies(query)
    forkJoin([getDeals, getCurEqui]).subscribe(([deals, curEquiRes]) => {
      this.dealsData = deals;
      const dealEquivelents = this.convertCurEqiToObj(curEquiRes.payload);
      deals.forEach(deal => {
        if (dealEquivelents[deal.code]) {
          deal.baseAmount = dealEquivelents[deal.code].equivalents[this.baseCurrency];
        }
      })      
      this.formulateData(deals);
    })
  }
  formulateData(datas: DealModel[]) {
    datas.forEach(data => {
      const month = new Date(data.createdDate).getMonth();
      this.updateMonth(month, data.baseAmount);
    })
    if (this.selectedPeriod === 'quaterly') {
      const { quatersLabel, quarters } = this.dateUtil.getQuarterlyData(this.months);
      this.chartOptions.xaxis.categories = quatersLabel
      this.chartOptions.series[0].data = quarters;
      this.result = quarters
    } else {
      const result = [];
      Object.values(this.months).forEach(v => result.push(v))
      this.chartOptions.series[0].data = result;
      this.chartOptions.xaxis.categories = this.dateUtil.monthList;
      this.result = result;
    }
  }
  updateMonth(mnth, amount) {
    let count = this.months[mnth];
    if (count || count === 0) {
      count = count + Number(amount)
    }
    this.months[mnth] = count;
  }
  resetGraph() {
    this.result = null;
    this.months = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  }
  convertCurEqiToObj(datas: any[]) {
    const obj = {};
    datas.forEach(dat => obj[dat.itemId] = dat)
    return obj
  }
  getNewDeals() {
    this.dataTable.rows = null;
    this.reportSetSrv.getReportConfig().subscribe(repSet => {
      const config = repSet ? repSet.newDealDays : 0;
      const { startDate, endDate } = this.getDealQuery(config, 0);      
      const query = `itemType=Deals&range={"createdOn":{"from":${startDate},"to":${endDate}}}`;
      const getCurEqui = this.currencySrv.filter_organisation_currencies(query);
      const getDeals = this.dealSrv.getAllDealsStatusStatistics(this.getDealQuery(config, 0))
      forkJoin([getDeals, getCurEqui]).subscribe(([res, curEquiRes]) => {
        const deals = [];
        res.forEach(dt => {
          deals.push(...dt.deals)
        });
        const dealEquivelents = this.convertCurEqiToObj(curEquiRes.payload);
        deals.forEach(deal => {
          if (dealEquivelents[deal.code]) {
          deal.baseAmount = dealEquivelents[deal.code].equivalents[this.baseCurrency];
          } else {
            deal.baseAmount = 0
          }
        });
        this.unfilteredTableResult = deals;
        this.getTableData(deals);
      })
    })
  }
  getTableData(deals: DealModel[]) {
    const salesPerDeals = {};
    const salespersonNames = {};
    deals.forEach(deal => {
      if(salesPerDeals[deal.creatorID]) {
        let { count, amount } = salesPerDeals[deal.creatorID];
        count = count + 1
        amount = amount + deal.baseAmount;
        salesPerDeals[deal.creatorID] = {count, amount};
      } else {
        salespersonNames[deal.creatorID] = deal.source;
        salesPerDeals[deal.creatorID] = {count: 1, amount: deal.baseAmount}
      }
    });
    const result = [];
    Object.keys(salesPerDeals).forEach(salesper => {
      const { count, amount } = salesPerDeals[salesper];
      result.push({name: salespersonNames[salesper], count, amount })
    });
    this.dataTable.rows = result;
    this.dataTable.dataChangedObs.next(true);
  }
  filterTable() {
    let result = [];
    if(this.selectedStatus) {
      const status = Number(this.selectedStatus);
      result = this.unfilteredTableResult.filter(deal => deal.status == status);
    } else {
      result = this.unfilteredTableResult;
    }    
    this.getTableData(result);
  }



}
